import { filter } from "lodash"

export default function getSectionsAnchors(body) {
  return filter(body, b => b.component === "section").map(s => {
    return {
      anchor: `section-${s._uid}`,
      title: s.anchor || s.title,
    }
  })
}
